"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _isEmpty = _interopRequireDefault(require("lodash/isEmpty"));

var _findMediaObject = _interopRequireDefault(require("../utils/findMediaObject"));

var _source = _interopRequireDefault(require("./source"));

var _image = _interopRequireDefault(require("./image"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ReactHTMLPicture = function ReactHTMLPicture(_ref) {
  var alt = _ref.alt,
      _ref$lazy = _ref.lazy,
      lazy = _ref$lazy === void 0 ? true : _ref$lazy,
      media = _ref.media,
      mediaFormats = _ref.mediaFormats,
      _ref$path = _ref.path,
      path = _ref$path === void 0 ? "" : _ref$path,
      xs = _ref.xs,
      sm = _ref.sm,
      md = _ref.md,
      lg = _ref.lg,
      xl = _ref.xl,
      PictureProps = _ref.PictureProps;
  var xsMedia;
  var smMedia;
  var mdMedia;
  var lgMedia;
  var xlMedia;

  if (!(0, _isEmpty.default)(mediaFormats)) {
    xsMedia = (mediaFormats === null || mediaFormats === void 0 ? void 0 : mediaFormats.xs) && (0, _findMediaObject.default)(media, mediaFormats === null || mediaFormats === void 0 ? void 0 : mediaFormats.xs);
    smMedia = (mediaFormats === null || mediaFormats === void 0 ? void 0 : mediaFormats.sm) && (0, _findMediaObject.default)(media, mediaFormats === null || mediaFormats === void 0 ? void 0 : mediaFormats.sm);
    mdMedia = (mediaFormats === null || mediaFormats === void 0 ? void 0 : mediaFormats.md) && (0, _findMediaObject.default)(media, mediaFormats === null || mediaFormats === void 0 ? void 0 : mediaFormats.md);
    lgMedia = (mediaFormats === null || mediaFormats === void 0 ? void 0 : mediaFormats.lg) && (0, _findMediaObject.default)(media, mediaFormats === null || mediaFormats === void 0 ? void 0 : mediaFormats.lg);
    xlMedia = (mediaFormats === null || mediaFormats === void 0 ? void 0 : mediaFormats.xl) && (0, _findMediaObject.default)(media, mediaFormats === null || mediaFormats === void 0 ? void 0 : mediaFormats.xl);
  } else {
    xsMedia = xs && (0, _findMediaObject.default)(media, xs);
    smMedia = sm && (0, _findMediaObject.default)(media, sm);
    mdMedia = md && (0, _findMediaObject.default)(media, md);
    lgMedia = lg && (0, _findMediaObject.default)(media, lg);
    xlMedia = xl && (0, _findMediaObject.default)(media, xl);
  }

  var fbMedia = null;
  if (!(0, _isEmpty.default)(xsMedia)) fbMedia = xsMedia;
  if (!(0, _isEmpty.default)(smMedia)) fbMedia = smMedia;
  if (!(0, _isEmpty.default)(mdMedia)) fbMedia = mdMedia;
  if (!(0, _isEmpty.default)(lgMedia)) fbMedia = lgMedia;
  if (!(0, _isEmpty.default)(xlMedia)) fbMedia = xlMedia;
  var xsMediaFB = null;
  var smMediaFB = null;
  var mdMediaFB = null;
  var lgMediaFB = null;
  var xlMediaFB = null;
  xsMediaFB = xsMedia && (0, _findMediaObject.default)(media, xsMedia.fallbackFormatIdentifier);
  smMediaFB = smMedia && (0, _findMediaObject.default)(media, smMedia.fallbackFormatIdentifier);
  mdMediaFB = mdMedia && (0, _findMediaObject.default)(media, mdMedia.fallbackFormatIdentifier);
  lgMediaFB = lgMedia && (0, _findMediaObject.default)(media, lgMedia.fallbackFormatIdentifier);
  xlMediaFB = xlMedia && (0, _findMediaObject.default)(media, xlMedia.fallbackFormatIdentifier);
  if (!(0, _isEmpty.default)(xsMediaFB)) fbMedia = xsMediaFB;
  if (!(0, _isEmpty.default)(smMediaFB)) fbMedia = smMediaFB;
  if (!(0, _isEmpty.default)(mdMediaFB)) fbMedia = mdMediaFB;
  if (!(0, _isEmpty.default)(lgMediaFB)) fbMedia = lgMediaFB;
  if (!(0, _isEmpty.default)(xlMediaFB)) fbMedia = xlMediaFB;
  if (!fbMedia) return null;
  return /*#__PURE__*/_react.default.createElement("picture", PictureProps, !(0, _isEmpty.default)(xlMedia) && /*#__PURE__*/_react.default.createElement(_source.default, {
    breakpoint: "xl",
    file: path + xlMedia.filename,
    filetyp: xlMedia.fileType,
    height: xlMedia.height,
    width: xlMedia.width
  }), !(0, _isEmpty.default)(xlMediaFB) && /*#__PURE__*/_react.default.createElement(_source.default, {
    breakpoint: "xl",
    file: path + xlMediaFB.filename,
    filetyp: xlMediaFB.fileType,
    height: xlMediaFB.height,
    width: xlMediaFB.width
  }), !(0, _isEmpty.default)(lgMedia) && /*#__PURE__*/_react.default.createElement(_source.default, {
    breakpoint: "lg",
    file: path + lgMedia.filename,
    filetyp: lgMedia.fileType,
    height: lgMedia.height,
    width: lgMedia.width
  }), !(0, _isEmpty.default)(lgMediaFB) && /*#__PURE__*/_react.default.createElement(_source.default, {
    breakpoint: "lg",
    file: path + lgMediaFB.filename,
    filetyp: lgMediaFB.fileType,
    height: lgMediaFB.height,
    width: lgMediaFB.width
  }), !(0, _isEmpty.default)(mdMedia) && /*#__PURE__*/_react.default.createElement(_source.default, {
    breakpoint: "md",
    file: path + mdMedia.filename,
    filetyp: mdMedia.fileType,
    height: mdMedia.height,
    width: mdMedia.width
  }), !(0, _isEmpty.default)(mdMediaFB) && /*#__PURE__*/_react.default.createElement(_source.default, {
    breakpoint: "md",
    file: path + mdMediaFB.filename,
    filetyp: mdMediaFB.fileType,
    height: mdMediaFB.height,
    width: mdMediaFB.width
  }), !(0, _isEmpty.default)(smMedia) && /*#__PURE__*/_react.default.createElement(_source.default, {
    breakpoint: "sm",
    file: path + smMedia.filename,
    filetyp: smMedia.fileType,
    height: smMedia.height,
    width: smMedia.width
  }), !(0, _isEmpty.default)(smMediaFB) && /*#__PURE__*/_react.default.createElement(_source.default, {
    breakpoint: "sm",
    file: path + smMediaFB.filename,
    filetyp: smMediaFB.fileType,
    height: smMediaFB.height,
    width: smMediaFB.width
  }), !(0, _isEmpty.default)(xsMedia) && /*#__PURE__*/_react.default.createElement(_source.default, {
    breakpoint: "xs",
    file: path + xsMedia.filename,
    filetyp: xsMedia.fileType,
    height: xsMedia.height,
    width: xsMedia.width
  }), !(0, _isEmpty.default)(xsMediaFB) && /*#__PURE__*/_react.default.createElement(_source.default, {
    breakpoint: "xs",
    file: path + xsMediaFB.filename,
    filetyp: xsMediaFB.fileType,
    height: xsMediaFB.height,
    width: xsMediaFB.width
  }), /*#__PURE__*/_react.default.createElement(_image.default, {
    alt: alt,
    file: path + fbMedia.filename,
    height: fbMedia.height,
    lazy: lazy,
    title: fbMedia.title,
    width: fbMedia.width
  }));
};

ReactHTMLPicture.propTypes = {
  alt: _propTypes.default.string,
  lazy: _propTypes.default.bool,
  media: _propTypes.default.object.isRequired,
  mediaFormats: _propTypes.default.object,
  path: _propTypes.default.string,
  xs: _propTypes.default.string,
  sm: _propTypes.default.string,
  md: _propTypes.default.string,
  lg: _propTypes.default.string,
  xl: _propTypes.default.string
};
var _default = ReactHTMLPicture;
exports.default = _default;